import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const KEY = "kb_cookie_consent";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(KEY)) setVisible(true);
    }, []);

    const accept = () => { localStorage.setItem(KEY, "accepted"); setVisible(false); };
    const decline = () => { localStorage.setItem(KEY, "declined"); setVisible(false); };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ type: "spring", damping: 28, stiffness: 260 }}
                    className="fixed bottom-4 left-4 right-4 z-[9999] md:left-auto md:right-6 md:bottom-6 md:max-w-md"
                >
                    <div className="bg-nova-surface border border-white/10 rounded-2xl p-5 shadow-2xl shadow-black/60 backdrop-blur-md">
                        <div className="flex items-start gap-3 mb-4">
                            <div className="w-9 h-9 rounded-xl bg-nova-cyan/10 border border-nova-cyan/20 flex items-center justify-center shrink-0 mt-0.5">
                                <Cookie className="w-4 h-4 text-nova-cyan" />
                            </div>
                            <div>
                                <p className="font-heading font-bold text-white text-sm mb-1">Táto stránka používa cookies</p>
                                <p className="text-zinc-400 text-xs leading-relaxed">
                                    Používame nevyhnutné cookies pre správne fungovanie stránky. Analytické cookies používame len s vaším súhlasom.
                                </p>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <button
                                onClick={decline}
                                className="flex-1 h-9 rounded-lg border border-white/10 text-zinc-400 text-xs font-mono uppercase tracking-wide hover:bg-white/5 hover:text-white transition-all"
                            >
                                Odmietnuť
                            </button>
                            <button
                                onClick={accept}
                                className="flex-1 h-9 rounded-lg bg-nova-cyan text-black text-xs font-mono font-bold uppercase tracking-wide hover:saturate-125 transition-all"
                            >
                                Prijať všetky
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
